var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Text, Box, NoData, Icon, useMediaQuery } from 'shared/components';
import { StatusTable, TableCellLink } from 'shared/features/table';
import { defaultPageSizeOptions } from 'constants/table';
import { DateTime } from 'luxon';
import { VErrorIcon } from '@springcare/sh-component-library';
import { CheckCircle } from 'src/shared/assets/icons';
import { getDateRelatedToState } from '../utils';
import { EHR_DATE_FORMAT, MONTH_DAY_YEAR_FORMAT, StatusTextEnum } from '../constants';
import { UnkownMessage } from './UnkownMessage';
import { EmptyState } from 'src/shared/assets/images/EmptyState';
export var InvoicesTable = function (_a) {
    var data = _a.data, isError = _a.isError, isLoading = _a.isLoading;
    var isPrint = useMediaQuery('print')[0];
    var cols = [
        {
            Header: 'Service Period',
            id: 'period_start',
            accessor: function (row) { return row === null || row === void 0 ? void 0 : row.period_start; },
            Cell: function (_a) {
                var _b, _c;
                var row = _a.row;
                var start = row.original.period_start
                    ? DateTime.fromFormat(row.original.period_start, EHR_DATE_FORMAT)
                    : null;
                var end = row.original.period_end
                    ? DateTime.fromFormat(row.original.period_end, EHR_DATE_FORMAT)
                    : null;
                if (!start || !end)
                    return _jsx(UnkownMessage, {});
                return (_jsxs(TableCellLink, __assign({ "data-testid": "invoicePeriod", to: "/pay/invoice/".concat(row.original.id) }, { children: [(_b = start === null || start === void 0 ? void 0 : start.toFormat('MMM d')) !== null && _b !== void 0 ? _b : '', " - ", (_c = end === null || end === void 0 ? void 0 : end.toFormat(MONTH_DAY_YEAR_FORMAT)) !== null && _c !== void 0 ? _c : ''] })));
            },
        },
        {
            Header: 'Status',
            accessor: function (row) { return row === null || row === void 0 ? void 0 : row.state; },
            Cell: function (_a) {
                var _b;
                var row = _a.row;
                var relatedDate = getDateRelatedToState(row.original);
                var date = relatedDate ? DateTime.fromFormat(relatedDate, EHR_DATE_FORMAT) : null;
                return (_jsxs(_Fragment, { children: [_jsx(Text, __assign({ display: "flex", alignItems: "center", "data-testid": "past-payment-status-".concat(row.index) }, { children: StatusTextEnum[row.original.state] })), _jsx(Text, __assign({ display: "flex", alignItems: "center", mt: "2", size: "small" }, { children: (_b = date === null || date === void 0 ? void 0 : date.toFormat(MONTH_DAY_YEAR_FORMAT)) !== null && _b !== void 0 ? _b : '' }))] }));
            },
        },
        {
            Header: 'Payment Amount',
            accessor: function (row) { return row === null || row === void 0 ? void 0 : row.pay_amount_cents; },
            Cell: function (_a) {
                var row = _a.row;
                var paymentFormeted = "".concat((row.original.pay_amount_cents / 100).toLocaleString('en-US', {
                    style: 'currency',
                    currency: row.original.pay_amount_currency,
                }));
                return (_jsxs(_Fragment, { children: [_jsxs(Text, __assign({ "data-testid": "payment", size: "body1", color: "green.500", display: "flex", alignItems: "center", fontWeight: "bold" }, { children: [_jsx(Icon, { boxSize: 4, width: "24px", height: "24px", as: CheckCircle, mr: "2" }), paymentFormeted] })), _jsxs(Text, __assign({ size: "small", mt: "2" }, { children: [row.original.line_items_count, " notes"] }))] }));
            },
        },
        {
            Header: 'Denials',
            accessor: function (row) { return row === null || row === void 0 ? void 0 : row.denied_amount_cents; },
            Cell: function (_a) {
                var row = _a.row;
                return (_jsx(Box, __assign({ display: "flex", alignItems: "start" }, { children: _jsxs(Text, __assign({ "data-testid": "denied", size: "body1", color: row.original.denied_count > 0 ? 'warning.onLight' : 'gray.500', fontWeight: row.original.denied_count > 0 ? 'bold' : 'inherit', display: "flex", alignItems: "center" }, { children: [_jsx(Icon, { boxSize: 4, width: "24px", height: "24px", as: VErrorIcon, mr: "2" }), row.original.denied_count, " notes"] })) })));
            },
        },
    ];
    return (_jsx(StatusTable, { cols: cols, data: data, cellProps: { verticalAlign: 'top', paddingTop: 3, paddingBottom: 3, px: 3 }, initialState: { sortBy: [{ id: 'period_start', desc: true }] }, isLoading: isLoading, isError: isError, noData: _jsx(NoData, { title: "You do not have any payments to display.", icon: _jsx(EmptyState, {}) }), maxWidth: "100%", paginated: !isPrint, pageSizeOptions: defaultPageSizeOptions, sx: {
            WebkitPrintColorAdjust: 'exact',
            printColorAdjust: 'exact',
            td: {
                pageBreakInside: 'avoid',
            },
            th: {
                paddingLeft: 0,
                paddingRight: 0,
                '& > div > div > div': {
                    paddingLeft: 3,
                    paddingRight: 3,
                    marginLeft: 0,
                },
            },
            pageBreakInside: 'avoid',
            'tr > th:first-of-type': {
                paddingLeft: 0,
                '& > div > div > div': {
                    paddingLeft: 3,
                },
            },
            'tr > th:last-of-type': {
                paddingRight: 0,
            },
        } }));
};
